import { get, noop } from 'lodash';
import { connect } from 'react-redux';
import InternalLink from '../../components/link/internal-link';
import { navigateToForum } from '../../services/navigate-to-section';

export default {
  Link: InternalLink,
  MembersLink: connect(() => ({ to: `/members` }))(InternalLink),
  ProfileLink: connect((state, { user }) => ({ to: `/profiles/${get(user, 'slug')}` }))(InternalLink),
  FollowingLink: connect((state, { user }) => ({ to: `/profiles/${get(user, 'slug')}/following` }))(InternalLink),
  FollowersLink: connect((state, { user }) => ({ to: `/profiles/${get(user, 'slug')}/followers` }))(InternalLink),
  SettingsLink: connect((state, { user }) => ({ to: `/profiles/${get(user, 'slug')}/settings` }))(InternalLink),
  NotificationsLink: connect(() => ({ to: `/notifications` }))(InternalLink),
  navigateToMembers: () => navigateToForum('/members'),
  navigateToProfile: user => navigateToForum(`/profiles/${get(user, 'slug')}`),
  navigateToProfileSettings: user => navigateToForum(`/profiles/${get(user, 'slug')}/settings`),
  navigateToNotifications: () => navigateToForum('/notifications'),
  navigateToEditPost: location => navigateToForum(location),
  navigateToCreatePost: noop,
  navigateToMyDrafts: noop,
};



// WEBPACK FOOTER //
// ./app/services/navigation-provider/forum.js